export const PREMIUM_SERVICE_LEVEL = 'Premium'
export const STANDARD_SERVICE_LEVEL = 'Standard'
